import { GetServerSideProps } from "next";
import { useRouter } from "next/router";
import { useState, useEffect } from "react";
import Meta from "../../../app/component/commons/meta/Meta";
import { DetailRegionProps } from "../../../app/helpers/types/getTypes";
import DefaultLayout from "../../../app/layouts/DefaultLayout";
import RegionDetail from "../../../app/layouts/partials/RegionDetail";
import { client } from "../../../app/utils/axios";

interface Props {
  params: DetailRegionProps;
}

const Index = ({ params }: Props) => {
  const router = useRouter();
  const [mode, setMode] = useState("");

  useEffect(() => {
    // window.analytics.page("viewed");
    if (window.innerWidth < 768) {
      setMode("mobile");
    } else {
      setMode("desktop");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Meta
        title={`Find Storage Unit Auctions Happening In ${params.state.name} | StorageUnitAuctionList.com`}
        description={`Find Storage Unit Auctions happening by city in ${params.state.name} and every major city in the United States. Signup in minutes to get access to the most up to date list of storage unit auctions happening near you.`}
      />
      <DefaultLayout>
        <div className="container mx-auto ">
          {mode && <RegionDetail data={params} type="state" mode={mode} />}
        </div>
      </DefaultLayout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  let params = {};

  try {
    const { data } = await client.get(`/m/facility/state`, {
      ...context,
      params: {
        slug: context.query.slug,
      },
    });

    if (data) {
      params = data;
    }

    return {
      props: { params },
    };
  } catch (error: any) {
    if (error.response) {
      return {
        redirect: {
          permanent: false,
          destination: `/${error.response.status}`,
        },
      };
    }

    return {
      redirect: {
        permanent: false,
        destination: "/404",
      },
    };
  }
};

export default Index;
